
// tools and component for date picker
import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

//import fr from 'dayjs/locale/fr';
const fr = require('dayjs/locale/fr')
dayjs.locale(fr);


const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)

function BlocJours({ dateRef }) {

    let listJours = []

    for (let i = 0; i < 7; i++) {
        listJours.push(dayjs(dateRef).weekday(i))
    }

    return (
        <div className="ligne-contrat">
            <div className="ligne-contrat-nom">

            </div>
            <div className="ligne-semaine-jour">
                {listJours.map(j => <span><p>{dayjs(j).format("dddd DD/MM")}</p></span>)}

            </div>
        </div>
    );
}

export default BlocJours